import config from 'app-self-support-order/config'

const crmThirdPartyShopApi = `${config.apiHost}/oem-crm_third_party_shop`
const ewechatMsgApi = `${config.apiHost}/oem-ewechat_msg`

export default {
    getAutoRelateSetting: {
        url: `${ewechatMsgApi}/api/config/msg_auto_bind_customer`,
        type: 'GET',
    },
    setAutoRelateStatus: {
        url: `${ewechatMsgApi}/api/config/msg_auto_bind_customer`,
        type: 'PUT',
    },
    getAutoRelateUsers: {
        url: `${ewechatMsgApi}/api/config/archive_users`,
        type: 'GET',
    },
    // 获取扩展资料中-自动绑定订单手机号-状态
    getBindPhoneStatus: {
        url: `${crmThirdPartyShopApi}/api/config/phone-num/auto-save`,
        type: 'GET',
    },
    // 变更扩展资料中-自动绑定订单手机号-状态
    setBindPhoneStatus: {
        url: `${crmThirdPartyShopApi}/api/config/phone-num/auto-save`,
        type: 'PUT',
    },

    // 获取扩展资料中-自动关联订单手机号-状态
    getRelatePhoneStatus: {
        url: `${crmThirdPartyShopApi}/api/config/phone-num/auto-bind`,
        type: 'GET',
    },
    // 变更扩展资料中-自动关联订单手机号-状态
    setRelatePhoneStatus: {
        url: `${crmThirdPartyShopApi}/api/config/phone-num/auto-bind`,
        type: 'PUT',
    },
}
